import { useState } from "react";
import { Link } from "react-router-dom";

function Sitetest() {
  const [ilsan02_msg, setIlsan02Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [songpa03_msg, setSongpa03Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장

  const [boryeong11_msg, setBoryeong11Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [boryeong12_msg, setBoryeong12Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [boryeong13_msg, setBoryeong13Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [boryeong14_msg, setBoryeong14Msg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [siheung_msg, setSiheungMsg] = useState("클릭 없음"); // 클릭된 버튼 정보 상태값으로 저장
  const [siheungDistance, setSiheungDistance] = useState("");
  const [siheungChannel3Distance, setSiheungChannel3Distance] = useState("");
  const [siheungServerStatus, setSiheungServerStatus] = useState("대기");
  const [siheungRelayStatus, setSiheungRelayStatus] = useState("대기");
  const [siheungIsSending, setSiheungIsSending] = useState(false);

  const SIHEUNG_SITE_ID = "siheung01";
  const SIHEUNG_FIXED_CHANNEL_3_DISTANCE = 650;
  const SENSOR_ADD_URL = "http://3.38.180.149:8080/dtxiot/sensor/add";
  const SIHEUNG_RELAY_URL =
    process.env.REACT_APP_SIHEUNG_RELAY_URL || "http://127.0.0.1:8787";

  const postSensorMessage = async (message) => {
    const response = await fetch(SENSOR_ADD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ xmlText: message }),
    });

    if (!response.ok) {
      throw new Error("실서버 전송 실패");
    }

    return response;
  };

  const sendMessage = async (message) => {
    try {
      await postSensorMessage(message);
      console.log("메시지를 성공적으로 전송했습니다.");
    } catch (error) {
      console.error(error);
    }
  };

  const sendSiheungRelayCommand = async ({
    button,
    distance,
    channel3Distance,
    clickedAt,
  }) => {
    const response = await fetch(`${SIHEUNG_RELAY_URL}/api/siheung/command`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        button,
        distance,
        channel3Distance,
        clickedAt,
      }),
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok || !payload?.ok) {
      throw new Error(payload?.message || "자동전송 등록 실패");
    }

    return payload;
  };

  const formatSiheungDateTime = (value) => {
    if (!value) {
      return "-";
    }

    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
      return value;
    }

    return parsedDate.toLocaleString("ko-KR", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getSiheungStatusClassName = (statusText) => {
    if (
      statusText.includes("실패") ||
      statusText.includes("미등록") ||
      statusText.includes("필수")
    ) {
      return "text-red-500";
    }

    if (statusText.includes("대기") || statusText.includes("전송 중")) {
      return "text-slate-600";
    }

    if (
      statusText.includes("완료") ||
      statusText.includes("등록")
    ) {
      return "text-emerald-600";
    }

    return "text-slate-600";
  };

  const getSiheungDistanceValue = (distance) => {
    const trimmedDistance = String(distance).trim();

    if (trimmedDistance === "") {
      return null;
    }

    const parsedDistance = Number(trimmedDistance);

    if (!Number.isFinite(parsedDistance)) {
      return null;
    }

    return Math.max(0, Math.trunc(parsedDistance));
  };

  const createSiheungMessage = ({
    distance,
    channel3Distance,
    errorChannels,
  }) => {
    const parsedDistance = getSiheungDistanceValue(distance) ?? 0;
    const parsedChannel3Distance =
      getSiheungDistanceValue(channel3Distance) ??
      SIHEUNG_FIXED_CHANNEL_3_DISTANCE;
    const startDetectors = [1, 2, 3, 4]
      .map(
        (channel) =>
          `<detector><siteId>${SIHEUNG_SITE_ID}</siteId><chNum>${channel}</chNum><detNum>1</detNum><status>1</status><distance>${
            errorChannels.includes(channel)
              ? channel === 3
                ? parsedChannel3Distance
                : parsedDistance
              : 0
          }</distance><btAmt>22.84</btAmt></detector>`,
      )
      .join("");
    const endDetectors = [1, 2, 3, 4]
      .map(
        (channel) =>
          `<detector><siteId>${SIHEUNG_SITE_ID}</siteId><chNum>${channel}</chNum><detNum>2</detNum><status>${
            errorChannels.includes(channel) ? 2 : 1
          }</status><distance>0</distance><btAmt>${
            errorChannels.includes(channel) ? 0 : 22.84
          }</btAmt></detector>`,
      )
      .join("");

    return `<XML>${startDetectors}${endDetectors}</XML>`;
  };

  const messages = {
    songpa03_ok: `<XML><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    songpa03_det1: `<XML><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    songpa03_det2: `<XML><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    songpa03_det3: `<XML><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>955</distance><btAmt>22.84</btAmt></detector><detector><siteId>songpa03</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,

    ilsan02_ok: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.64</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.63</btAmt></detector></XML>`,
    ilsan02_ac_ch1: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.63</btAmt></detector></XML>`,
    ilsan02_ac_ch2: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.64</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    ilsan02_ac_ch12: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    ilsan02_det2_ch1: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>580</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.63</btAmt></detector></XML>`,
    ilsan02_det2_ch2: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>580</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.64</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    ilsan02_det2_ch12: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>580</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>580</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    ilsan02_det3_ch1: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>530</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.63</btAmt></detector></XML>`,
    ilsan02_det3_ch2: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>530</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>1</status><distance>0</distance><btAmt>22.64</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    ilsan02_det3_ch12: `<XML><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>530</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>530</distance><btAmt>22.84</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>1</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>ilsan02</siteId><chNum>2</chNum><detNum>3</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,

    boryeong11_ok: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_start_ch1: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_start_ch2: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_start_ch12: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_end_ch1: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>424</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_end_ch2: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>424</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong11_end_ch12: `<XML><detector><siteId>boryeong11</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>424</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong11</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>424</distance><btAmt>22.84</btAmt></detector></XML>`,

    boryeong13_ok: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_start_ch1: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_start_ch2: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_start_ch12: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_end_ch1: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>305</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_end_ch2: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>305</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong13_end_ch12: `<XML><detector><siteId>boryeong13</siteId><chNum>1</chNum><detNum>1</detNum><status>2</status><distance>305</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong13</siteId><chNum>2</chNum><detNum>1</detNum><status>2</status><distance>305</distance><btAmt>22.84</btAmt></detector></XML>`,

    boryeong12_ok: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_start_ch1: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_start_ch2: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_start_ch3: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_start_ch4: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    boryeong12_end_ch1: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_end_ch2: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_end_ch3: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong12_end_ch4: `<XML><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong12</siteId><chNum>4</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,

    boryeong14_ok: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_start_ch1: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_start_ch2: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_start_ch3: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_start_ch4: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,
    boryeong14_end_ch1: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_end_ch2: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_end_ch3: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector></XML>`,
    boryeong14_end_ch4: `<XML><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>1</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>1</detNum><status>1</status><distance>750</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>1</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>2</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>3</chNum><detNum>2</detNum><status>1</status><distance>0</distance><btAmt>22.84</btAmt></detector><detector><siteId>boryeong14</siteId><chNum>4</chNum><detNum>2</detNum><status>2</status><distance>0</distance><btAmt>0</btAmt></detector></XML>`,

  };

  const sendMessageWithParams = async (message, additionalParam, site) => {
    try {
      await sendMessage(message);

      switch (site) {
        case "ilsan02":
          setIlsan02Msg(additionalParam);
          break;

        case "songpa03":
          setSongpa03Msg(additionalParam);
          break;

        case "boryeong11":
          setBoryeong11Msg(additionalParam);
          break;
        case "boryeong12":
          setBoryeong12Msg(additionalParam);
          break;
        case "boryeong13":
          setBoryeong13Msg(additionalParam);
          break;
        case "boryeong14":
          setBoryeong14Msg(additionalParam);
          break;
        case SIHEUNG_SITE_ID:
          setSiheungMsg(additionalParam);
          break;
        default:
          // 처리할 사이트가 없을 때의 기본 동작
          console.log("hahah");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const siheungButtonConfigs = [
    {
      label: "ALL OK",
      description: "3ch 빼고 모두 정상, 3ch은 ch3 입력값 에러",
      errorChannels: [3],
      buttonClassName: "bg-emerald-600 text-white",
    },
    {
      label: "ALL ERROR",
      description: "1,2,4채널 입력한 미터값, 3채널은 ch3 입력값 에러",
      errorChannels: [1, 2, 3, 4],
    },
    {
      label: "1ch error",
      description: "1채널 입력한 미터값, 3채널은 ch3 입력값 에러",
      errorChannels: [1, 3],
    },
    {
      label: "2ch error",
      description: "2채널 입력한 미터값, 3채널은 ch3 입력값 에러",
      errorChannels: [2, 3],
    },
    {
      label: "3ch error",
      description: "3채널은 ch3 입력값 에러",
      disabled: true,
    },
    {
      label: "4ch error",
      description: "4채널 입력한 미터값, 3채널은 ch3 입력값 에러",
      errorChannels: [3, 4],
    },
  ];

  const handleSiheungButtonClick = async (button) => {
    const parsedDistance = getSiheungDistanceValue(siheungDistance);
    const parsedChannel3Distance = getSiheungDistanceValue(
      siheungChannel3Distance,
    );

    if (parsedDistance === null) {
      setSiheungMsg("거리 입력은 필수입니다");
      setSiheungServerStatus("대기");
      setSiheungRelayStatus("대기");
      return;
    }

    if (parsedChannel3Distance === null) {
      setSiheungMsg("3ch 거리 입력은 필수입니다");
      setSiheungServerStatus("대기");
      setSiheungRelayStatus("대기");
      return;
    }

    const clickedAt = new Date().toISOString();
    const clickLabel = `${button.label} (${parsedDistance}m / 3ch ${parsedChannel3Distance}m)`;
    const siheungMessage = createSiheungMessage({
      distance: parsedDistance,
      channel3Distance: parsedChannel3Distance,
      errorChannels: button.errorChannels,
    });

    setSiheungIsSending(true);
    setSiheungServerStatus("전송 중...");
    setSiheungRelayStatus("등록 대기...");

    try {
      await postSensorMessage(siheungMessage);
      setSiheungMsg(clickLabel);
      setSiheungServerStatus("완료");
    } catch (error) {
      console.error(error);
      setSiheungServerStatus(error.message || "실패");
      setSiheungRelayStatus("미등록 (실서버 전송 실패)");
      setSiheungIsSending(false);
      return;
    }

    try {
      const relayResponse = await sendSiheungRelayCommand({
        button: button.label,
        distance: parsedDistance,
        channel3Distance: parsedChannel3Distance,
        clickedAt,
      });
      setSiheungRelayStatus(
        `${relayResponse.message} (다음 전송 ${formatSiheungDateTime(
          relayResponse.nextRunAt,
        )})`,
      );
    } catch (error) {
      console.error(error);
      setSiheungRelayStatus(error.message || "자동전송 등록 실패");
    } finally {
      setSiheungIsSending(false);
    }
  };

  return (
    <div className="flex justify-center items-center px-2">
      <div className="flex-col justify-center items-center">
        {/* 시흥현장 */}
        <div className="my-[50px]  lg:px-[150px] flex-col ">
          <div className="text-3xl font-bold">시흥현장</div>
          <div className="flex items-center gap-3 pt-4">
            <div className="text-xl">거리입력 :</div>
            <input
              type="number"
              min="0"
              value={siheungDistance}
              onChange={(e) => setSiheungDistance(e.target.value)}
              placeholder=""
              className="w-[120px] border border-slate-400 px-3 py-2 text-lg"
            />
            <div className="text-xl">m</div>
            <div className="text-sm text-slate-500">
              (거리입력은 필수입니다)
            </div>
          </div>
          <div className="flex items-center gap-3 pt-3">
            <div className="text-xl">3ch 거리입력 :</div>
            <input
              type="number"
              min="0"
              value={siheungChannel3Distance}
              onChange={(e) => setSiheungChannel3Distance(e.target.value)}
              placeholder=""
              className="w-[120px] border border-slate-400 px-3 py-2 text-lg"
            />
            <div className="text-xl">m</div>
            <div className="text-sm text-slate-500">
              (3ch 거리입력은 필수입니다)
            </div>
          </div>
          <div className="space-y-3 pt-6">
            {siheungButtonConfigs.map((button) => (
              <div key={button.label} className="flex items-center gap-4">
                <button
                  className={
                    button.disabled
                      ? "bg-slate-200 text-slate-400 px-4 lg:px-10 py-3 min-w-[140px] cursor-not-allowed"
                      : `${button.buttonClassName || "bg-slate-600 text-white"} px-4 lg:px-10 py-3 min-w-[140px] ${
                          siheungIsSending ? "opacity-60 cursor-not-allowed" : ""
                        }`
                  }
                  disabled={button.disabled || siheungIsSending}
                  onClick={
                    button.disabled || siheungIsSending
                      ? undefined
                      : () => handleSiheungButtonClick(button)
                  }
                >
                  {button.label}
                </button>
                <div className="text-base lg:text-lg">{button.description}</div>
              </div>
            ))}
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {siheung_msg}
          </div>
          <div
            className={`mt-2 font-medium ${getSiheungStatusClassName(
              siheungServerStatus,
            )}`}
          >
            실서버 전송 : {siheungServerStatus}
          </div>
          <div
            className={`mt-1 font-medium ${getSiheungStatusClassName(
              siheungRelayStatus,
            )}`}
          >
            자동전송 : {siheungRelayStatus}
          </div>
        </div>

        {/* 일산현장 */}
        <div className="my-[50px] mt-[10px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">일산현장</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(messages.ilsan02_ok, "ok", "ilsan02")
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">AC전원 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_ac_ch1,
                    "ac전원 ch1",
                    "ilsan02",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_ac_ch2,
                    "ac전원 ch2",
                    "ilsan02",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_ac_ch12,
                    "ac전원 ch1&2",
                    "ilsan02",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">장비2 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det2_ch1,
                    "장비2 ch1",
                    "ilsan02",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det2_ch2,
                    "장비2 ch2",
                    "ilsan02",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det2_ch12,
                    "장비2 ch1&2",
                    "ilsan02",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">장비3 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det3_ch1,
                    "장비3 ch1",
                    "ilsan02",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det3_ch2,
                    "장비3 ch2",
                    "ilsan02",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.ilsan02_det3_ch12,
                    "장비3 ch1&2",
                    "ilsan02",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {ilsan02_msg}
          </div>
        </div>

        {/* 송파현장 */}
        <div className="my-[50px] mt-[10px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">송파현장</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(messages.songpa03_ok, "ok", "songpa03")
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">테스트위치 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.songpa03_det1,
                    "AC 장비",
                    "songpa03",
                  )
                }
              >
                AC 장비
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.songpa03_det2,
                    "태양광1",
                    "songpa03",
                  )
                }
              >
                태양광1
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.songpa03_det3,
                    "태양광2",
                    "songpa03",
                  )
                }
              >
                태양광2
              </button>
            </div>
          </div>

          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {songpa03_msg}
          </div>
        </div>

        {/* 율암교 */}
        <div className="my-[50px] mt-[10px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">율암교</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(
                  messages.boryeong11_ok,
                  "ok",
                  "boryeong11",
                )
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">AC전원 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_start_ch1,
                    "ac전원 ch1",
                    "boryeong11",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_start_ch2,
                    "ac전원 ch2",
                    "boryeong11",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_start_ch12,
                    "ac전원 ch1&2",
                    "boryeong11",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">점검구 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_end_ch1,
                    "점검구 ch1",
                    "boryeong11",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_end_ch2,
                    "점검구 ch2",
                    "boryeong11",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong11_end_ch12,
                    "점검구 ch1&2",
                    "boryeong11",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {boryeong11_msg}
          </div>
        </div>

        {/* 지우교 은해교 */}
        <div className="my-[50px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">지우교~은해교</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(
                  messages.boryeong12_ok,
                  "ok",
                  "boryeong12",
                )
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">AC전원 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_start_ch1,
                    "ac전원 ch1",
                    "boryeong12",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_start_ch2,
                    "ac전원 ch2",
                    "boryeong12",
                  )
                }
              >
                ch2
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_start_ch3,
                    "ac전원 ch3",
                    "boryeong12",
                  )
                }
              >
                ch3
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_start_ch4,
                    "ac전원 ch4",
                    "boryeong12",
                  )
                }
              >
                ch4
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">태양광 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_end_ch1,
                    "태양광 ch1",
                    "boryeong12",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_end_ch2,
                    "태양광 ch2",
                    "boryeong12",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_end_ch3,
                    "태양광 ch3",
                    "boryeong12",
                  )
                }
              >
                ch3
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong12_end_ch4,
                    "태양광 ch4",
                    "boryeong12",
                  )
                }
              >
                ch4
              </button>{" "}
            </div>
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {boryeong12_msg}
          </div>
        </div>

        {/* sk주유소 */}
        <div className="my-[50px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">sk주유소</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(
                  messages.boryeong13_ok,
                  "ok",
                  "boryeong13",
                )
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">AC전원 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_start_ch1,
                    "ac전원 ch1",
                    "boryeong13",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_start_ch2,
                    "ac전원 ch2",
                    "boryeong13",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_start_ch12,
                    "ac전원 ch1&2",
                    "boryeong13",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">점검구 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_end_ch1,
                    "점검구 ch1",
                    "boryeong13",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_end_ch2,
                    "점검구 ch2",
                    "boryeong13",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong13_end_ch12,
                    "점검구 ch1&2",
                    "boryeong13",
                  )
                }
              >
                ch1&2
              </button>
            </div>
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {boryeong13_msg}
          </div>
        </div>

        {/* 지티삼거리 */}
        <div className="my-[50px]  lg:px-[150px] flex-col ">
          <div className="flex items-center gap-6">
            <div className="text-3xl font-bold">지티삼거리</div>
            <button
              className="bg-slate-800 text-white px-6 lg:px-20 py-3"
              onClick={() =>
                sendMessageWithParams(
                  messages.boryeong14_ok,
                  "ok",
                  "boryeong14",
                )
              }
            >
              ok
            </button>
          </div>
          <div className="flex items-center pt-4 ">
            <h1 className="pr-2 text-xl">AC전원 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_start_ch1,
                    "ac전원 ch1",
                    "boryeong14",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_start_ch2,
                    "ac전원 ch2",
                    "boryeong14",
                  )
                }
              >
                ch2
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_start_ch3,
                    "ac전원 ch3",
                    "boryeong14",
                  )
                }
              >
                ch3
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_start_ch4,
                    "ac전원 ch4",
                    "boryeong14",
                  )
                }
              >
                ch4
              </button>
            </div>
          </div>
          <div className="flex items-center pt-4">
            <h1 className="pr-2 text-xl">태양광 : </h1>
            <div className="flex gap-3 ">
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_end_ch1,
                    "태양광 ch1",
                    "boryeong14",
                  )
                }
              >
                ch1
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_end_ch2,
                    "태양광 ch2",
                    "boryeong14",
                  )
                }
              >
                ch2
              </button>{" "}
              <button
                className="bg-slate-300 px-3 lg:px-10 py-3"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_end_ch3,
                    "태양광 ch3",
                    "boryeong14",
                  )
                }
              >
                ch3
              </button>
              <button
                className="bg-slate-300 px-3 lg:px-10"
                onClick={() =>
                  sendMessageWithParams(
                    messages.boryeong14_end_ch4,
                    "태양광 ch4",
                    "boryeong14",
                  )
                }
              >
                ch4
              </button>{" "}
            </div>
          </div>
          <div className="mt-6 font-semibold text-red-500">
            최근클릭 : {boryeong14_msg}
          </div>
        </div>

        {/* 설명 */}
        <div className="flex-col text-lg  space-y-4">
          <div className="text-2xl font-semibold">설명(사용법)</div>
          <div> ok버튼 : 해당 사이트 모든 채널 정상값으로 세팅</div>
          <div>
            ch버튼 : 해당 채널만 비정상 값으로 세팅, 나머지 채널은 다 정상으로
            세팅{" "}
          </div>
          <div>
            * (주의) ac전원 ch1 클릭한뒤, 점검구 ch2 클릭하면 → 점검구 ch2만
            비정상..(ac전원 ch1은 정상)
          </div>

          <div>
            밑에 빨간메시지 보고 내가 가장 마지막으로 뭘 클릭했는지 확인가능...
            현재 DTX 상태 유추 가능
          </div>

          <div>
            채널4개 구간에서.. 채널1이랑 채널3 끊어서 보여주세요 → 못보여줌
          </div>
        </div>
        <Link to={"/sitetest-check"}>
          <div className="bg-orange-400 w-full p-4 text-center mt-10 text-white text-xl">
            커스텀 페이지로 이동
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Sitetest;
